import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeRectangleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeRectangle" ref={ref} {...props}>
    <path d="M17.73,21.49H6.25A3.75,3.75,0,0,1,2.5,17.74V6.26A3.75,3.75,0,0,1,6.25,2.51H17.73a3.76,3.76,0,0,1,3.75,3.75V17.74A3.76,3.76,0,0,1,17.73,21.49ZM6.25,4A2.25,2.25,0,0,0,4,6.26V17.74A2.25,2.25,0,0,0,6.25,20H17.73A2.25,2.25,0,0,0,20,17.74V6.26A2.25,2.25,0,0,0,17.73,4Z" />
  </Icon>
)) as IconWithRender;

ShapeRectangleIcon.displayName = 'ShapeRectangleIcon';
ShapeRectangleIcon.renderIcon = (props) => <ShapeRectangleIcon {...props} />;
export default ShapeRectangleIcon;
